import React, { useEffect } from "react";
import { Link } from "react-router-dom";

const CapitalMarkets = () => {
  useEffect(() => {
    // Scroll to the banner section on page load
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <section className="banner1">
        <div className="banner-overlay1"></div>
        <div className="banner-content">
          <h6 className="banner-subtitle">Services / Capital Market</h6>
          <hr />
          <h1 className="banner-title">
            Innovating Capital Market <br /> Operations with Cutting-edge
            Software Solutions
          </h1>

          <p>
            Unlock new opportunities and optimize trading, investment
            management, <br /> and compliance processes with advanced
            technologies tailored to the capital market industry.
          </p>

          <button className="banner-button mt-3">
            <Link to="/contact" className="text-decoration-none text-white">
              Let’s talk <span className="arrow">→</span>
            </Link>
          </button>
        </div>

        {/* Add the image element */}
        <img
          className="banner-image"
          src="https://img.freepik.com/free-photo/forex-trade-graph-chart-concept_53876-132317.jpg"
          alt="Capital Market Solutions"
        />
      </section>

      <section id="about" className="about py-5">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h6 className="col_yell text-center">Capital Market</h6>
              <h2 className="text-center">
                Empowering Capital Market Firms with Intelligent Solutions
              </h2>
              <p className="text-center">
                The capital markets are evolving rapidly with increasing
                regulatory pressure and the need for more efficient trading and
                investment management systems. Our software solutions provide
                the necessary tools to navigate these challenges, driving
                profitability and compliance in an increasingly complex market.
              </p>
            </div>
          </div>
        </div>
      </section>
      <hr />

      <div className="container-fluid" style={{ padding: 40 }}>
        <div className="row serv_h1 mb-4">
          <div className="col-md-12">
            <div className="serv_h1l mb-4">
              <h2 className="text-center">Our Solutions</h2>
              <p className="text-center mb-0">
                From trading platforms to risk management and compliance
                systems, we offer a comprehensive suite of software solutions
                that enable capital market firms to optimize their operations,
                improve decision-making, and meet regulatory requirements.
              </p>
            </div>
          </div>
        </div>

        <div className="row g-4">
          <div className="col-md-6">
            <div className="p-4 border rounded bg-white card-hover">
              <h3 className="mb-3 card-title">
                <a href="#">Trading Platforms</a>
              </h3>
              <p className="mb-4">
                Our trading platform solutions provide capital market firms with
                fast, secure, and intuitive platforms for executing orders,
                monitoring market trends, and analyzing assets in real-time.
              </p>
            </div>
          </div>

          <div className="col-md-6">
            <div className="p-4 border rounded bg-white card-hover">
              <h3 className="mb-3 card-title">
                <a href="#">Investment Management Systems</a>
              </h3>
              <p className="mb-4">
                Our investment management software helps firms track
                investments, manage portfolios, analyze performance, and ensure
                compliance with financial regulations.
              </p>
            </div>
          </div>

          <div className="col-md-6">
            <div className="p-4 border rounded bg-white card-hover">
              <h3 className="mb-3 card-title">
                <a href="#">Risk Management Solutions</a>
              </h3>
              <p className="mb-4">
                We provide risk management software that identifies and
                mitigates financial, operational, and market risks, ensuring
                firms can make informed decisions and manage exposure
                effectively.
              </p>
            </div>
          </div>

          <div className="col-md-6">
            <div className="p-4 border rounded bg-white card-hover">
              <h3 className="mb-3 card-title">
                <a href="#">Market Analytics and Insights</a>
              </h3>
              <p className="mb-4">
                Our market analytics software provides advanced tools for
                analyzing financial data, identifying market trends, and
                forecasting investment opportunities to support smarter
                decision-making.
              </p>
            </div>
          </div>
        </div>
      </div>

      <hr />

      <section id="serv_h" className="p_3">
        <div className="container-xl">
          <div className="row serv_h3 mt-4 pt-5 pb-5 mx-0 px-4 bg-black text-white">
            <div className="col-md-8">
              <div className="serv_h3l">
                <h2 className="">
                  Ready to Transform Your Capital Market Operations?
                </h2>
                <p className="mt-3">
                  Leverage advanced software to enhance your trading strategies,
                  manage investment portfolios efficiently, and ensure full
                  regulatory compliance with our industry-leading solutions.
                </p>
                <button className="banner-button mt-3">
                  <Link
                    to="/contact"
                    className="text-decoration-none text-white"
                  >
                    Let’s talk <span className="arrow">→</span>
                  </Link>
                </button>
              </div>
            </div>
            <div className="col-md-4">
              <div className="serv_h3r">
                <div className="grid clearfix">
                  <figure className="effect-jazz mb-0">
                    <Link to="/contact">
                      <img
                        src="https://img.freepik.com/free-photo/colleagues-working-together-office_23-2148738266.jpg"
                        className="w-100"
                        alt="Capital Market Solutions"
                      />
                    </Link>
                  </figure>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CapitalMarkets;
